export const PRODUCT_STATE = {
  isRealSoldOut: 'isRealSoldOut',
  isNotAvailable: 'isNotAvailable',
  isAvailable: 'isAvailable',
} as const
export type ProductState = keyof typeof PRODUCT_STATE

export const INGREDIENT_TEXT = {
  LOW_PROTEIN: '저단백',
  HIGH_PROTEIN: '고단백',
  LOW_FAT: '저지방',
  LOW_PHOSPHORUS: '인수치 낮은',
} as const
export type IngredientText = keyof typeof INGREDIENT_TEXT

export const FEED_TEXT = {
  FEED: '사료',
  FEED_SNACK: '간식',
} as const

export type FeedText = keyof typeof FEED_TEXT

export const BannerState = {
  timeSale: 'timeSale',
  isSoldOut: 'isSoldOut',
} as const

export type BannerState = keyof typeof BannerState
